var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.header))]),_c('kst-value',{attrs:{"field":"ClientID","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-value',{attrs:{"field":"ClientAddress","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-value',{attrs:{"field":"PONumber","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }